import React, { Component } from "react";
import DetailPatient from "../form/DetailPatient.js";
import { Route, Switch, Link } from "react-router-dom";
import { modules } from "../../routes";
import { DetilPxContext } from "../../context";
import Gigi from "../gigi/Gigi";
import ProtectedRoute from "../../ProtectedRoute.js";
import Alergi from "../form/Alergi";
class PelayananPx extends Component {
  static contextType = DetilPxContext;
  constructor(props) {
    super(props);
    this.state = {
      modules: [],
      visible: false,
    };
  }

  buttonClick = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    var patient = this.context.data;
    let module = []; let clinic = [];
    let mod = JSON.parse(localStorage.getItem("module"));
    if (mod !== null) {
      mod.filter(v => v.modules.group === 'visitRanap').forEach((data, key) => {
        module[key] = modules.find((element) => element.name === data.modules.name);
        clinic.push(data.clinic_id);
      });
    }
    // module = found;
    let modulex = module.filter(
      (element) => element !== undefined
    );

    module = modulex
    return (
      <div>
        <div className="container-fluid my-3">
          <div className="row">
            <div className="col">
              <div className="row">
                <div className="col-xl-3 order-xl-1">
                  <DetailPatient patient={patient} />
                  <div className="card">
                    <div className="card-header">
                      <h4>Modul</h4>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        {module.map((modul, key) => {
                          if (modul.menu === "pelayanan") {
                            if (patient.clinic_id === clinic[key]) {
                              return (
                                <div key={modul.moduleId} className="col-6">
                                  <Link
                                    style={{
                                      whiteSpace: "normal",
                                      paddingLeft: "2Px",
                                      paddingRight: "2Px",
                                    }}
                                    className="btn btn-primary btn-block"
                                    to={this.props.match.url + modul.path}
                                    key={modul.moduleId}
                                    onClick={window.scrollTo(0, 50)}
                                  >
                                    {modul.name}
                                  </Link>
                                  <br></br>
                                </div>
                              );
                            }
                          }
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <Alergi patient={patient} />
                  </div>
                </div>

                <div className="col-xl-9 order-xl-2">
                  <Switch>
                    {module.map(({ component: Component, ...rest }, key) => {
                      if (patient.clinic_id === clinic[key]) {
                        return (
                          <Route
                            path={this.props.match.url + rest.path}
                            render={(props) => (
                              <Component {...props} detilPx={patient} />
                            )}
                            key={key}
                          />
                        );
                      }
                    })}
                  </Switch>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PelayananPx;
